<template>
    <div class="content-font">

        <div class="bg-white p25" :class="{ sm: small,lg:!small}"
             style="box-sizing: border-box; width:100%;margin:auto;line-height: 1.2em;">
            <table style="width:100%">
                <tr>
                    <td style="font-size: x-small;text-align: left">
                        <div v-if="small">
                            <div style="font-weight: bold" class="font-gold">HIVE PROPERTIES PTY LTD</div>
                            A.B.N. 21 169 314 112<br/><br/>
                        </div>
                        91 CANTERBURY ROAD, CANTERBURY, VIC 3126 <br/>
                        PROJECT ENQUIRY: 1300 918 920<br/>
                        EMAIL: ENQUIRIES@HIVE.PROPERTIES
                    </td>
                    <td style="text-align: right" v-if="!small">
                        <div style="font-weight: bold" class="font-gold">HIVE PROPERTIES PTY LTD</div>
                        A.B.N. 21 169 314 112
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
	export default {
		name: "ContactCard",
		computed: {
			small() {
				return this.$mq === 'sm';
			}
		}
	}
</script>

<style scoped>
    div {
        box-sizing: border-box;
    }

    .p25 {
        padding: 25px;
    }

    .sm {
        max-width: 600px;
    }

    .lg {
        max-width: 1206px;
    }
</style>